import { chakra, UnorderedList } from '@chakra-ui/react';

export const UploadRequestList = chakra(UnorderedList, {
  baseStyle: {
    display: 'flex',
    flexDirection: 'column',
    gap: 8,
    listStyleType: 'none',
    marginBottom: 8,
  },
});
